import { render, staticRenderFns } from "./saleInvoiceApproval.vue?vue&type=template&id=9f4a0f1a&"
import script from "./saleInvoiceApproval.vue?vue&type=script&lang=js&"
export * from "./saleInvoiceApproval.vue?vue&type=script&lang=js&"
import style0 from "./saleInvoiceApproval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports